"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Gabe Kelley, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1740))
 * @trackcomponent
 * @lastsynced 2025-04-16T17:02:16.206Z
 * @optimized using svgo:^3.0.2
 */
export const StarFilled = createSVGIcon(
  <path
    d="m12.843 1.87 2.714 5.501a.94.94 0 0 0 .708.515l6.072.884a.94.94 0 0 1 .514 1.603l-4.395 4.286a.94.94 0 0 0-.27.831l1.038 6.055a.94.94 0 0 1-1.372.99l-5.415-2.848a.94.94 0 0 0-.874 0l-5.43 2.856a.94.94 0 0 1-1.37-.99L5.798 15.5a.94.94 0 0 0-.269-.832l-4.388-4.289a.94.94 0 0 1 .514-1.603l6.079-.89a.94.94 0 0 0 .708-.514l2.714-5.5a.941.941 0 0 1 1.686 0"
    fill="currentColor"
  />,
  "StarFilled",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
